import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Geodetic Datum List with Query (for remote operations)
export const getGeodeticDatumListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_GEODETIC_DATUMS}?${stringifyParams(
			params
		)}`
	);
};

// Get Geodetic Datum List with Query
export const getGeodeticDatumList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		// populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_GEODETIC_DATUMS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Geodetic Datum
export const getGeodeticDatum = geodetic_datum_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_GEODETIC_DATUM}${geodetic_datum_id}`
	);
};

// Add New Geodetic Datum
export const addNewGeodeticDatumApi = geodetic_datum => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_GEODETIC_DATUM}`,
		geodetic_datum
	);
};

// Update Geodetic Datum
export const updateGeodeticDatumApi = geodetic_datum => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_GEODETIC_DATUM}${geodetic_datum._id}`,
		geodetic_datum
	);
};

// Delete Geodetic Datum
export const deleteGeodeticDatumApi = geodetic_datum_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_GEODETIC_DATUM}${geodetic_datum_id}`
	);
};

// Check if Geodetic Datum Exists
export const checkGeodeticDatumExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_GEODETIC_DATUM_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
